import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  NbComponentStatus,
  NbDialogRef,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbTagComponent,
  NbTagInputAddEvent,
  NbToastrService,
} from "@nebular/theme";
import * as _ from "lodash";
import { remove } from "lodash";
import { EMAIL_PATTERN } from "../../@auth/components/constants";
import { Person } from "../../models/person.model";

import { PersonService } from "../../services/person.service";
import { DialogImagesUploadComponent } from "../dialog-images-upload/dialog-images-upload.component";
import { DialogYesNoPromptComponent } from "../dialog-yesno-prompt/dialog-yesno-prompt.component";

@Component({
  selector: "ngx-dialog-person",
  templateUrl: "dialog-person.component.html",
  styleUrls: ["dialog-person.component.scss"],
})
export class DialogPersonComponent implements OnInit {
  @Input() header: string;
  @Input() mode: string;
  @Input() person: Person = new Person();

  status: string = "0";
  trees: Set<string> = new Set([]);
  diaForm: FormGroup;
  submitted = false;
  loading = false;
  edited = false;
  imageURL = "";
  imagesUrl = [];
  menu = "info";

  constructor(
    protected ref: NbDialogRef<DialogPersonComponent>,
    private fb: FormBuilder,
    private personService: PersonService,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService
  ) {}

  ngOnInit() {
    const fullNameValidators = [
      Validators.minLength(1),
      Validators.maxLength(250),
      Validators.required,
    ];
    const mobileValidators = [Validators.required];
    const stringValidators = [
      Validators.minLength(1),
      Validators.maxLength(500),
    ];
    const emailValidators = [Validators.pattern(EMAIL_PATTERN)];

    this.diaForm = this.fb.group({
      fullName: ["", fullNameValidators],
      description: ["", stringValidators],
      dob: [],
      gender: [],
      mobile: ["", mobileValidators],
      cardId: [],
      email: ["", emailValidators],
      address: ["", stringValidators],
      tax: [],
    });

    if (!this.person.dob) {
      this.person.dob = new Date();
    }

    if (this.person.tags && this.person.tags.length > 0) {
      var trees = new Set([]);
      this.person.tags.forEach(function (value) {
        trees.add(value);
      });
      this.trees = trees;
    } else {
      this.trees.add("KH");
    }
    if (!this.person.sourceType || this.person.sourceType == "") {
      this.person.sourceType = "document";
    }
    if (!this.person.gender) {
      this.person.gender = "Khác";
    }
    if (this.person.coverUrl && this.person.coverUrl != "") {
      this.imageURL = this.person.coverUrl;
    }
    if (this.person.imagesUrl && this.person.imagesUrl.length > 0) {
      this.imagesUrl = _.clone(this.person.imagesUrl);
    }
    if (!this.person.content) {
      this.person.content = "";
    }
  }

  cancel() {
    if (this.edited) {
      this.ref.close(this.person);
    } else {
      this.ref.close();
    }
  }

  selectMenu(value) {
    this.menu = value;
  }

  submit() {
    this.submitted = true;

    var tags: string[] = [];
    this.trees.forEach(function (item) {
      tags.push(item);
    });
    this.person.tags = tags;
    this.person.email = this.person.email ? this.person.email : "";
    this.person.mobile = this.person.mobile
      ? this.person.mobile.replace(" ", "").trim()
      : "";

    this.person.cardId = this.person.cardId ? this.person.cardId : "";
    this.person.coverUrl = this.person.coverUrl ? this.person.coverUrl : "";
    this.person.fullName = this.person.fullName ? this.person.fullName : "";
    if (this.person.fullName != "") {
      this.person.lastName = this.person.fullName.split(" ")[0].trim();
      this.person.firstName = this.person.fullName
        .replace(this.person.lastName, "")
        .trim();
    }
    if (this.person.dob) {
      this.person.dobYear = new Date(this.person.dob).getFullYear();
      this.person.dobMonth = new Date(this.person.dob).getMonth() + 1;
      this.person.dobDay = new Date(this.person.dob).getDate();
    }

    this.person.gender = this.person.gender ? this.person.gender : "Khác";
    this.person.address = this.person.address ? this.person.address : "";
    this.person.tax = this.person.tax ? this.person.tax : "";
    this.person.description = this.person.description
      ? this.person.description
      : "";
    this.person.tags = this.person.tags ? this.person.tags : [];
    this.person.imagesUrl = this.person.imagesUrl ? this.person.imagesUrl : [];

    if (this.mode == "edit") {
      this.edit();
    } else {
      this.create();
    }
  }

  create() {
    this.loading = true;
    this.submitted = true;

    console.log("create:", this.person);

    this.personService
      .create(this.person)
      .then((data) => {
        this.person = data;

        this.loading = false;
        this.submitted = false;

        this.ref.close(this.person);
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
      });
  }

  edit() {
    this.loading = true;
    this.submitted = true;

    this.personService
      .update(this.person)
      .then((data) => {
        this.loading = false;
        this.submitted = false;

        this.edited = true;
        this.ref.close(this.person);
        this.showToast("success", "Cập nhật nhà cung cấp", "thành công");
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
        this.showToast("warning", "Cập nhật nhà cung cấp", "thất bại");
      });
  }

  delete(item: Person) {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa thông tin này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.personService
            .delete(item.shopId, item.id)
            .then((result) => {
              this.loading = false;
              this.submitted = false;
              this.ref.close(this.person);
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
            });
        }
      });
  }

  //Images
  openGallery() {
    this.dialogService
      .open(DialogImagesUploadComponent, {
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.addImage(value);
        }
      });
  }

  updateImage(imageUrl) {
    if (imageUrl && imageUrl != "") {
      this.person.coverUrl = imageUrl;
      this.imageURL = imageUrl.replace("_400x400", "");
    }
  }
  removeCoverUrl() {
    this.person.coverUrl = "";
    this.imageURL = "/assets/images/image-upload-bg.jpg";
  }

  addImage(obj) {
    let imageURL = obj.value;

    if (!this.person.imagesUrl) {
      this.person.imagesUrl = [];
    }
    this.person.imagesUrl.push(imageURL);

    if (obj.isNew) {
      imageURL = imageURL.replace("_400x400", "");
    }
    this.imagesUrl.push(imageURL);
  }

  deleteImage(item) {
    remove(this.person.imagesUrl, (el) => {
      return el == item;
    });
    remove(this.imagesUrl, (el) => {
      return el == item;
    });
  }

  //Tags
  onTagRemove(tagToRemove: NbTagComponent): void {
    this.trees.delete(tagToRemove.text);
  }

  onTagAdd({ value, input }: NbTagInputAddEvent): void {
    if (value) {
      this.trees.add(value);
    }
    input.nativeElement.value = "";
  }

  // control event
  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
